// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import i18n from 'app/common/lib/i18n';
import ProfileBoardCardContainer from 'app/common/react/components/profile/ProfileBoardCard/ProfileBoardCardContainer';
import ProfileBoardCardWrapper from 'app/common/react/components/profile/ProfileBoards/ProfileBoardCardWrapper';
import ProfileBoardsListHeader from 'app/common/react/components/profile/ProfileBoards/ProfileBoardsListHeader';
import ProfileGridLayout from 'app/common/react/components/profile/ProfileGridLayout/ProfileGridLayout';
import stopProfileTiming from 'app/common/react/components/profile/ProfileBoards/utils/stopProfileTiming';
import type { Dispatch } from 'redux';
import { Box } from 'gestalt';
import { createStructuredSelector } from 'reselect';
import { getBoardsContent } from 'app/common/redux/selectors/board';
import { logCustomTraceEvent } from 'app/common/lib/TraceLogger/logTraceEvent';
import { type State as ReduxBoard } from 'app/common/redux/reducers/board';
import {
  getCardWidth,
  type ProfileBoardCardLayout,
} from 'app/common/react/components/profile/ProfileBoardCard/layout';

type OwnProps = {|
  boardIds: Array<string>,
  layout: 'list' | ProfileBoardCardLayout,
  onBoardArchiveChange: () => void,
  onBoardDelete: () => void,
  showCreatorProfile: boolean,
|};

type ReduxProps = {|
  boardMap: { [string]: ReduxBoard },
|};

type Props = {|
  ...OwnProps,
  ...ReduxProps,
  dispatch: Dispatch<any>,
|};

const CONTAINER_EXTRA_WIDTH = 24;

export class ArchivedBoardList extends React.PureComponent<Props> {
  componentDidMount() {
    const { boardIds, boardMap, showCreatorProfile } = this.props;
    logCustomTraceEvent({ name: 'ArchivedBoardsListMountedTraceEvent' });
    logCustomTraceEvent({ name: 'MasonryDidMount' });
    if (this.container) {
      logCustomTraceEvent({
        name: 'UserNavRegisterGridImagesTraceEvent',
        viewportFilled: false,
        gridData: boardIds.map((boardId) => boardMap[boardId]).filter((board) => !!board),
        el: this.container.current,
      });
    }
    logCustomTraceEvent({ name: 'UserNavRegisterGridItemsPositionedTraceEvent' });
    stopProfileTiming({ isOwnProfile: true, showCreatorProfile });
  }

  container = React.createRef<HTMLElement>();

  render() {
    const { boardIds, boardMap, layout, onBoardArchiveChange, onBoardDelete } = this.props;

    if (!boardIds.length) {
      return null;
    }
    const boardRepContainerWidth =
      layout === 'list' ? '100%' : getCardWidth(layout) + CONTAINER_EXTRA_WIDTH;
    return (
      <Box ref={this.container}>
        {layout === 'list' && (
          <ProfileBoardsListHeader
            headerLabel={i18n._('Archived on', 'Profile board list view heading label')}
          />
        )}
        <ProfileGridLayout itemWidth={boardRepContainerWidth}>
          {boardIds
            .map((boardId) => boardMap[boardId])
            .filter((board) => !!board)
            .map((board: ReduxBoard, index: number) => (
              <ProfileBoardCardWrapper
                key={board.id}
                containerWidth={boardRepContainerWidth}
                inListView={layout === 'list'}
              >
                <ProfileBoardCardContainer
                  board={board}
                  isOwnProfile
                  layout={layout}
                  onBoardArchiveChange={onBoardArchiveChange}
                  onBoardDelete={onBoardDelete}
                  slotIndex={index}
                />
              </ProfileBoardCardWrapper>
            ))}
        </ProfileGridLayout>
      </Box>
    );
  }
}

// $FlowFixMe: new errors found from react-redux upgrade
export default connect<Props, OwnProps, _, _, _, _>(
  createStructuredSelector({
    boardMap: getBoardsContent,
  }),
)(ArchivedBoardList);
